import { render, staticRenderFns } from "./team_badge.vue?vue&type=template&id=803e5d7e&scoped=true&"
import script from "./team_badge.vue?vue&type=script&lang=js&"
export * from "./team_badge.vue?vue&type=script&lang=js&"
import style0 from "./team_badge.vue?vue&type=style&index=0&id=803e5d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803e5d7e",
  null
  
)

export default component.exports